<script>

import { State } from '../store.js';
import JSONTree from 'svelte-json-tree'

$: value = $State

</script>

<div class="state-debug-container">
    <JSONTree {value} />
</div>

<style>

    .state-debug-container {
        display: flex;
        flex-direction: column;
        flex-basis: auto;
        justify-self: stretch;
        justify-content: stretch;
        flex-grow: 5;
        width: 100%;
        --json-tree-string-color: deepskyblue;
        --json-tree-symbol-color: deepskyblue;
        --json-tree-boolean-color: deepskyblue;
        --json-tree-function-color: deepskyblue;
        --json-tree-number-color: deepskyblue;
        --json-tree-label-color: coral;
        --json-tree-arrow-color: white;
        --json-tree-null-color: white;
        --json-tree-undefined-color: white;
        --json-tree-date-color: white;
        --json-tree-li-indentation: 0.9em;
        --json-tree-li-line-height: 1.3rem;
        --json-tree-font-size: 1rem;
        --json-tree-font-family: 'Courier New', Courier, monospace;

    }


</style>